import {mapMutations, mapGetters, mapActions, createLogger} from "vuex";
import { minLength, required, maxLength } from "vuelidate/lib/validators";
import formEnterCode from "../enter-phone-form/enter-phone-step2/index.vue";
import { camelCase } from "lodash";

export default {
    name: "enter-form-phone",
    data() {
        return {
            payload: {
                phone: "",
            },
            validationErrors: {},
            step: "1",
        };
    },
    validations: {
        payload: {
            phone: {
                required,
                minLength: minLength(19),
            },
        },
    },
    components: {
        formEnterCode,
    },
    computed: {
        ...mapGetters({
            singInLoading: "auth/singInEmailLoading",
            sendCodeLoading: "auth/sendCodeLoading",
        }),
        phoneErrors() {
            let error = [];
            if (!this.$v.payload.phone.$dirty) {
                return error;
            }
            if (!this.$v.payload.phone.required) {
                error.push(this.$t("validationRequired"));
            }
            if (!this.$v.payload.phone.minLength) {
                error.push(this.$t("validationLengthPhone"));
            }
            if (this.validationErrors.phone) {
                this.validationErrors.phone.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        disableButton() {
            if (this.payload.phone === "") {
                return true;
            }
            return false;
        },
    },
    methods: {
        ...mapActions({
            singIn: `auth/GET_TOKEN_PHONE`,
            sendCode: `auth/SEND_CODE_PHONE`,
        }),
        ...mapMutations({}),
        submit() {
            this.$v.$touch();
            let obj = {};
            obj.phone = this.payload.phone.replace(/[\s.,%()-]/g, "");
            if (!this.$v.$invalid) {
                this.sendCode(obj)
                    .then(() => {
                        this.$toasted.success(this.$t("successSendCode"));
                        this.step = "2";
                    })
                    .catch(error => {
                        if (error.response.status === 403) {
                            this.$toasted.error(error.response.data.message);
                        }
                        if (error.response.status === 418) {
                            this.$toasted.error(error.response.data.message);
                            const errors = error.response.data.errors;
                            for (const i in errors) {
                                Vue.set(this.validationErrors, camelCase(i), errors[i]);
                                errors[i].forEach(e => {
                                    this.$toasted.error(e);
                                });
                            }
                        }
                        if (error.response.status === 422) {
                            this.$toasted.error(error.response.data.message);
                            const errors = error.response.data.errors;
                            for (const i in errors) {
                                Vue.set(this.validationErrors, camelCase(i), errors[i]);
                                errors[i].forEach(e => {
                                    this.$toasted.error(e);
                                });
                            }
                        }
                        if (error.response.status === 403) {
                            this.$toasted.error(error.response.data.errors);
                        }
                    });
            }
        },
    },
};
